import { render } from "./WeixinCallback.vue?vue&type=template&id=23c19502&scoped=true"
import script from "./WeixinCallback.vue?vue&type=script&lang=js"
export * from "./WeixinCallback.vue?vue&type=script&lang=js"

import "./WeixinCallback.vue?vue&type=style&index=0&id=23c19502&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c19502"]])

export default __exports__